import 'babel-polyfill'
import bugsnag from 'bugsnag-js'
import React from 'react'
import ReactDOM from 'react-dom'
import createPlugin from 'bugsnag-react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import BookingApp from 'cogsworth/components/BookingApp/BookingApp'
import { BUGSNAG_API_KEY, BUGSNAG_ENABLED } from 'cogsworth/constants'

import { I18nextProvider } from "react-i18next"
import i18n from "./cogsworth/i18n"

import './index.css'

const indexComponent = (
  <I18nextProvider i18n={i18n}>
    <BrowserRouter>
      <Switch>
        <Route path="/book" component={BookingApp}/>
      </Switch>
    </BrowserRouter>
  </I18nextProvider>
)

let rootComponent

// Load bugsnag in staging/production environments
if (BUGSNAG_API_KEY && BUGSNAG_ENABLED) {
  const bugsnagClient = bugsnag(BUGSNAG_API_KEY)
  const ErrorBoundary = bugsnagClient.use(createPlugin(React))

  rootComponent = (
    <ErrorBoundary>
      {indexComponent}
    </ErrorBoundary>
  )
}

// Clean environment in development
else {
  rootComponent = indexComponent
}

// Attach root component to DOM
ReactDOM.render(
  rootComponent,
  document.getElementById('root')
);
